import {moment} from 'external/moment'

export type Offer = {
	id: string
    active: boolean
    name: string
    plan: string
    price: string
    discount: boolean
    discount_amount: string,
    discount_type: 'quantity' | 'percent'
    discount_startdate: string
    discount_duedate: string
	content: {html: string, preview: string}
    month_number?: number
    start_date: string
    duration?: string
    loaded?: boolean
    frequency_unit_name: string
    category_unit: string
    frequency_unit: string
    discount_name: string
}

export const emptyOffer: Offer = {
    id: '',
    loaded: false,
    name: '',
    discount: false,
    discount_type: 'quantity',
    frequency_unit_name: '',
    start_date: '',
    active: false,
    content: {
        html: '',
        preview: ''
    },
    plan: "",
    price: "",
    discount_amount: "",
    discount_startdate: "",
    discount_duedate: "",
    category_unit: '',
    frequency_unit: '',
    discount_name: ''
}

export function isDiscounted(offer: Offer) {
    return offer.discount && moment().isBetween(moment(offer.discount_startdate), moment(offer.discount_duedate))
}

export function calculateDiscounts(offer: Offer) {
    let parsedPrice = parseFloat(offer.price.replace(/[$,]/g, ''));
    let discountedPrice = '';
    let discountedAmount = '';
    if (offer.discount_type === 'quantity') {
        discountedPrice = Number(parsedPrice - parseFloat(offer.discount_amount)).toFixed(2);
        discountedAmount = `$${offer.discount_amount}`;
    }
    if (offer.discount_type === 'percent') {
        const resultDiscount = (parseFloat(offer.discount_amount) * parsedPrice) / 100;
        discountedPrice = Number(parsedPrice - resultDiscount).toFixed(2);
        discountedAmount = `${Number(offer.discount_amount).toFixed(0)}%`;
    }
    return [discountedPrice, discountedAmount]
}